import { SiteNavLink } from "./site-nav-link";

interface CareerNavbarAuthButtonProps {
  onNavigate?: () => void;
  className?: string;
}

export function CareerNavbarAuthButton({
  onNavigate,
  className,
}: CareerNavbarAuthButtonProps) {
  return (
    <SiteNavLink href="/candidate/auth" onNavigate={onNavigate} className={className}>
      Candidate Portal
    </SiteNavLink>
  );
}
